<template>
    <div :style="[elementStyles, basicContentStyles]">
        <eicon kind="countdown" class="eicon-center text-white countdown overlay" :style="{'fontSize': Math.max(min_width_height/2, 20) + 'px'}"></eicon>
    </div>
</template>

<script>
    export default {
        props: ['data', 'frame', 'basicContentStyles', 'width', 'height'],
        data: function () {
            return {
                t_date_time_not_set: Lang.langGet("Date and/or time not set!"),
            }
        },
        computed: {
            min_width_height: function () {
                return Math.min(this.width, this.height);
            },
            elementStyles: function () {
                let backOpacity = 1;
                if(!isNaN(this.data.back_transparency) && this.data.back_transparency !== null) {
                    backOpacity -= this.data.back_transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                backOpacity = Math.min(backOpacity, 0.999);

                let backAlpha = (parseInt(backOpacity*255)).toString(16);
                if(backAlpha.length === 1) backAlpha = "0" + backAlpha;
                let backgroundColor = this.data.secondary_color + backAlpha;
                let opacity = 1;
                if(!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }

                return {
                    backgroundColor: backgroundColor,
                    opacity: opacity,
                }
            }
        }
    }
</script>
